export const actionTypes = {
  SET_ITEMS: 'IMAGE_MODAL:SET_ITEMS',
  OPEN: 'IMAGE_MODAL:OPEN',
  CLOSE: 'IMAGE_MODAL:CLOSE'
};

const actions = {
  setImages: items => ({
    type: actionTypes.SET_ITEMS,
    payload: items
  }),
  openImageModal: (image) => ({
    type: actionTypes.OPEN,
    payload: image
  }),
  closeImageModal: () => ({
    type: actionTypes.CLOSE,
  })
};

export default actions;
